/** The product name in every sentence a tenant or a sender reads. The code name stays "mailhand". */
export const PRODUCT_NAME = "Hooky";

/** The one product tagline, on the site and in the console. */
export const TAGLINE = "Your support inbox, handled.";

/** The public website, which holds the terms and the privacy policy. */
export const SITE_URL = "https://hooky.email";

/** Every email mailhand sends carries this header. The screen ignores inbound mail that has it. */
export const LOOP_HEADER = "X-Hooky-Loop";
